import axios from "@/utils/axios";
import axios2 from "axios";
import qs from "qs";

export default {
  //获取菜单
  menuTree(menuKey) {
    return axios.get(`/auth/menuTree`, {
      params: {
        menuKey,
      },
    });
  },
  // 验证码
  kaptcha() {
    return axios2.get("/achievement/auth/kaptcha", {
      responseType: "blob",
    });
  },
  // 修改密码
  modifyPassword(form) {
    return axios2.post("/achievement/auth/modifyPassword", form);
  },
  login(form) {
    return axios.post("/auth/login", form);
  },
  login_test(form) {
    return axios.post("/auth/dev_login?" + qs.stringify(form));
  },
  // 获取屯
  getNatureVillage(villageCode) {
    return axios.get("/division/natureVillage", {
      params: {
        villageCode,
      },
    });
  },
  /**
   * 获取下级行政区
   * @param {*} divisionnum 行政区编号
   */
  getDivision(divisionnum, source) {
    return axios.get("/division/children", {
      params: {
        divisionnum,
        source,
      },
    });
  },
  //获取行政区详情
  getDivisionDetail(divisionCode) {
    return axios.post(
      "/division/getdivisionbycode" + `?divisionCode=${divisionCode}`
    );
  },
};
